import { Component } from "@angular/core";

@Component({
  selector: "app-quickstart",
  imports: [],
  templateUrl: "./quickstart.component.html",
  styleUrl: "./quickstart.component.scss"
})
export class QuickstartComponent {}
